export default __webpack_public_path__ + "static/media/a011-fsi-09.f75f31ff.svg";